import type { AdResource } from "../Ad";

import { Ad } from "../Ad";

const InjectableNative = ({
  injectableNativeResource,
}: {
  injectableNativeResource: AdResource;
}) => {
  if (
    !injectableNativeResource ||
    !injectableNativeResource.havePlacementRule
  ) {
    return null;
  }

  return <Ad isInjectableNative resource={injectableNativeResource} />;
};

export { InjectableNative };
